import { NgModule } from '@angular/core';
import { BannerComponent } from './banner.component';

@NgModule({
  declarations: [BannerComponent],
  exports: [BannerComponent]
})
export class BannerModule {}
